import { useEffect } from 'react';
import { trackers } from '../../internal/platformMetrics/trackers';
export default {
    trackOrgGlobalsAreaCount: trackers.orgGlobalsAreaCount.track,
    trackBannerCount: trackers.bannerCount.track,
    trackDashboardPageTemplates: trackers.dashboardPageTemplates.track,
    trackStripeletCount: trackers.stripeletCount.track,
    trackTranslationCount: trackers.translationCount.track,
    translationCountForMessageLength: trackers.translationCountForMessageLength.track,
    useTrackMount: function useTrackMount(id) {
        useEffect(()=>trackers.usageByMount.track(id), [
            id
        ]);
    }
};

//# sourceMappingURL=platformMetrics.js.map